export default [
  {
    path: '/notificacao',
    name: 'Notificacao',
    meta: { descricao: 'Notificação' },
    component: () => import('@/pages/notificacao/Notificacao')
  },
]
